/**
 * A shared-directory doctor's pay, as core routes on it. Shown only on the
 * Shared Doctors pages, never on a clinic's Physicians page.
 */

import { useEffect, useState } from 'react'
import { Button, Input, Label } from './ui'

export function compLabel(c) {
  if (!c || c.payment_type === 'unknown') return 'unknown'
  if (c.payment_type === 'salary') return 'salary'
  return c.consult_rate_cents != null ? `$${(c.consult_rate_cents / 100).toFixed(0)}/consult` : 'per consult'
}

export default function CompensationEditor({ record, onSave }) {
  const c = record.compensation || {}
  const [type, setType] = useState(c.payment_type || 'unknown')
  const [rate, setRate] = useState(c.consult_rate_cents != null ? String(c.consult_rate_cents / 100) : '')
  useEffect(() => {
    setType(record.compensation?.payment_type || 'unknown')
    setRate(record.compensation?.consult_rate_cents != null ? String(record.compensation.consult_rate_cents / 100) : '')
  }, [record])

  const save = () => {
    if (type === 'unknown') return onSave(null)
    const next = { ...c, payment_type: type, currency: 'USD' }
    if (type === 'per_consult') {
      const dollars = Number(rate)
      if (!Number.isFinite(dollars) || dollars < 0) return alert('Enter a consult rate in dollars')
      next.consult_rate_cents = Math.round(dollars * 100)
    } else {
      next.consult_rate_cents = null
    }
    onSave(next)
  }

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-end gap-2">
        <div>
          <Label className="text-xs">Pay</Label>
          <select className="block h-9 rounded-md border px-2 text-sm" value={type} onChange={e => setType(e.target.value)}>
            <option value="salary">Salary</option>
            <option value="per_consult">Per consult</option>
            <option value="unknown">Unknown</option>
          </select>
        </div>
        {type === 'per_consult' && (
          <div>
            <Label className="text-xs">Rate ($)</Label>
            <Input className="h-9 w-24" value={rate} onChange={e => setRate(e.target.value)} inputMode="decimal" />
          </div>
        )}
        <Button size="sm" variant="outline" onClick={save}>Draft pay change</Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Routing prefers salary, then the lowest consult rate, then unknown. Salary amounts don't affect routing.
      </p>
    </div>
  )
}
